import React from 'react';

/**
 * 게임 목록 창 안의 상태 줄 — 목록을 기다리는 동안 안내하고, 못 받으면 사유와 [다시 시도]를 보여 준다.
 * WHY: 창은 카드를 누르는 즉시 열린다. 응답이 밀려도 회원이 바로 반응을 보고, 실패해도 알림창 없이 그 자리에서 다시 시도한다
 *      (2026-11-03 운영자 신고 "팝업이 늦게 뜨거나 뜨지 않는다").
 * 목록 격자 안에 들어가므로 격자 전체 폭을 차지한다. 글자색은 창의 색을 그대로 따른다(디자인마다 창 색이 다르다).
 */
const BOX_STYLE = { gridColumn: '1 / -1', textAlign: 'center', padding: '48px 16px', lineHeight: 1.6 };
const RETRY_STYLE = { marginTop: 12, padding: '8px 18px', border: '1px solid currentColor', borderRadius: 8, background: 'transparent', color: 'inherit', font: 'inherit', cursor: 'pointer' };

const GameListStatus = ({ loading, error, onRetry, className }) => {
  if (loading) return <div className={className} style={BOX_STYLE} role="status">게임 목록을 불러오는 중입니다.</div>;
  if (!error) return null;
  return (
    <div className={className} style={BOX_STYLE} role="alert">
      <div>{error}</div>
      <button type="button" style={RETRY_STYLE} onClick={onRetry}>다시 시도</button>
    </div>
  );
};

export default GameListStatus;
